import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, Grid, TextField, Typography, Alert, Stack } from "@mui/material";
import { CheckCircle, Payment } from "@mui/icons-material";
import belezaApi from "../../services/BelezaService";
import { moeda } from "../Beleza/shared";

const BelezaPublicCheckout = () => {
  const [plano, setPlano] = useState(null);
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", nomeEstabelecimento: "", cpfCnpj: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [checkout, setCheckout] = useState(null);

  useEffect(() => {
    belezaApi.saas.planoPublico().then(setPlano).catch(() => setPlano(null));
  }, []);

  const contratar = async () => {
    setLoading(true);
    setError("");
    try {
      const resp = await belezaApi.saas.criarCheckout(form);
      setCheckout(resp);
      const url = resp?.urlPagamento || resp?.paymentUrl || resp?.linkPagamento;
      if (url) window.location.href = url;
    } catch (err) {
      setError(err?.response?.data?.message || err.message || "Erro ao iniciar contratação.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0f172a", color: "#fff", display: "flex", alignItems: "center", p: { xs: 2, md: 4 } }}>
      <Grid container spacing={3} sx={{ maxWidth: 1180, mx: "auto" }} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography variant="overline" sx={{ color: "#38bdf8", fontWeight: 800 }}>TooAI Beleza</Typography>
          <Typography variant="h3" fontWeight={900} sx={{ lineHeight: 1.05, mb: 2 }}>
            Atendimento inteligente para salões e clínicas de estética.
          </Typography>
          <Typography variant="body1" sx={{ color: "#cbd5e1", mb: 3 }}>
            Agenda, atendimento, caixa, pacotes, produtos, relatórios e WhatsApp Oficial integrado via Meta Embedded Signup.
          </Typography>
          <Stack spacing={1.2}>
            {["Agenda inteligente com encaixe", "WhatsApp Oficial conectado pelo próprio cliente", "Caixa e financeiro integrados", "Relatórios gerenciais por unidade"].map((item) => (
              <Stack key={item} direction="row" spacing={1} alignItems="center"><CheckCircle color="success" /><span>{item}</span></Stack>
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent sx={{ p: { xs: 2, md: 4 } }}>
              <Typography variant="h5" fontWeight={900}>Começar agora</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Plano único {plano?.valorMensal ? `por ${moeda(plano.valorMensal)}/mês` : "com contratação online"}.
              </Typography>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              {checkout?.id && <Alert severity="success" sx={{ mb: 2 }}>Checkout criado. Redirecionando para pagamento...</Alert>}
              <Grid container spacing={1.5}>
                <Grid item xs={12}><TextField fullWidth size="small" label="Nome completo" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} /></Grid>
                <Grid item xs={12}><TextField fullWidth size="small" label="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Grid>
                <Grid item xs={12} sm={6}><TextField fullWidth size="small" label="Telefone/WhatsApp" value={form.telefone} onChange={(e) => setForm({ ...form, telefone: e.target.value })} /></Grid>
                <Grid item xs={12} sm={6}><TextField fullWidth size="small" label="CPF/CNPJ" value={form.cpfCnpj} onChange={(e) => setForm({ ...form, cpfCnpj: e.target.value })} /></Grid>
                <Grid item xs={12}><TextField fullWidth size="small" label="Nome do salão/clínica" value={form.nomeEstabelecimento} onChange={(e) => setForm({ ...form, nomeEstabelecimento: e.target.value })} /></Grid>
                <Grid item xs={12}>
                  <Button fullWidth size="large" variant="contained" startIcon={<Payment />} onClick={contratar} disabled={loading} sx={{ py: 1.3, fontWeight: 800 }}>
                    {loading ? "Gerando pagamento..." : "Contratar e pagar"}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BelezaPublicCheckout;
